import _cloneDeep from 'lodash/cloneDeep';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from 'formiojs';
import { CategoryConfig, OptionalInputConfig, QuestionConfig, AnswerConfig, AttachmentsConfig, EvaluationItemsConfig } from './../models/config.model';
import { AfterViewInit, Component, EventEmitter, Inject, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription, forkJoin, tap } from 'rxjs';
import { SortHelper } from '../../../helpers/sort.helper';
import { ToastrService } from 'ngx-toastr';
import { showToast } from '../../toast.helper';
import { FormioLoader, ResourceNameService } from 'dp-formio';

declare var $: any;

@Component({
    selector: 'app-assessment-control',
    templateUrl: './assessment-control.component.html',
    // styleUrls: ['./assessment-control.component.scss']
    encapsulation: ViewEncapsulation.None,
    providers: [FormioLoader]
})
export class AssessmentControlComponent implements OnInit, AfterViewInit, OnDestroy {

    currentQuestion: QuestionConfig;
    categoryHasChanged = new EventEmitter<CategoryConfig>();

    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }

    constructor(
        public dialogRef: MatDialogRef<AssessmentControlComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public formioLoader: FormioLoader,
        private toastrService: ToastrService,
        private translateService: TranslateService,
        private resourceNameService: ResourceNameService) {
    }

    ngOnInit() {
        if (this.data.subCategoryKey) {
            //load sub, then load subCat or question
            this.sub = this.loadSubCategores(this.data.currentLevel, true)
                .subscribe(data => {
                    const subCategory = this.data.currentLevel.subCategoriresObject.find(q => q.key == this.data.subCategoryKey);
                    this.openCategory(subCategory);
                });
        } else {
            this.loadData(this.data.currentLevel);
        }
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }

    ngAfterViewInit() {
        this.initProgressColor();
        this.selectDefaultQuestion();
    }

    close() {
        if (this.data.selected?.length > 1) {
            this.goTo(this.data.selected[this.data.selected.length - 2])
        }
        else this.dialogRef.close();
    }

    openCategory(item) {
        console.log(item);
        this.data.currentLevel = item;
        this.data.selected.push(item);
        this.loadData(item);
    }

    goTo(item) {
        console.log(item);
        const index = this.data.selected.findIndex(q => q.id == item.id);
        if (index >= 0) {
            this.data.currentLevel = item;
            this.data.selected.splice(index);
            if (!this.data.selected.length) { this.data.selected.push(item); }
        }
        this.initProgressColor();
        this.selectDefaultQuestion();
    }

    selectQuestion(question) {
        this.currentQuestion = question;
    }

    changedQuestion(question: QuestionConfig) {
        this.formioLoader.loading = true;
        const index = this.data.currentLevel.questionsAssessmentObject.findIndex(q => q._id == question._id);
        const progressChanged = this.data.currentLevel.questionsAssessmentObject[index].status != question.status;

        let questionBeforeUpdate = _cloneDeep(this.data.currentLevel.questionsAssessmentObject[index])

        this.data.currentLevel.questionsAssessmentObject[index] = question;
        this.data.currentLevel.questionsAssessmentObject = [...this.data.currentLevel.questionsAssessmentObject];
        this.data.currentLevel = this.data.currentLevel;
        this.currentQuestion = question;
        this.updateCategories(questionBeforeUpdate);
    }

    changedCategory(category: CategoryConfig) {
        this.data.currentLevel.optionalInputs = category.optionalInputs;
        this.data.currentLevel.descriptionStandardResult = category.descriptionStandardResult;
        this.data.currentLevel = this.data.currentLevel;
    }

    get currentPage() {
        let page = 0;
        if (this.data.dir == 'rtl') {
            page = Math.ceil(this.data.currentLevel.questionsAssessmentObject.length / 3) - 1;
        }
        return page < 0 ? 0 : page;
    }

    private updateCategories(questionBeforeUpdate?: QuestionConfig) {
        
        const calls = [];
        const completedQuestions = this.data.currentLevel.questionsAssessmentObject.filter(q => q.status).length;
        const allQuestions = this.data.currentLevel.questionsAssessmentObject.length;
        this.data.currentLevel.percentage = Math.ceil((completedQuestions / allQuestions) * 100);

        const categoryStat = this.calcCategoryStat(this.data.currentLevel, questionBeforeUpdate);
        console.log('categoryStat',categoryStat);
        this.data.currentLevel.numberOfApplicable = categoryStat.numberOfApplicable;
        this.data.currentLevel.totalEvaluationCriteria = parseFloat(categoryStat.totalEvaluationCriteria).toFixed(2);

        calls.push(this.resourceNameService.
            patchSubmission(this.data.customOptions.categoryResource,
                this.data.currentLevel._id,
                [{

                    "op": "add",
                    "path": "/data/percentage",
                    "value": this.data.currentLevel.percentage
                },
                {

                    "op": "add",
                    "path": "/data/scoreResult",
                    "value": parseFloat(this.data.currentLevel.calculatedScore).toFixed(2)
                },
                {

                    "op": "add",
                    "path": "/data/numberOfApplicable",
                    "value": this.data.currentLevel.numberOfApplicable
                },
                {

                    "op": "add",
                    "path": "/data/totalEvaluationCriteria",
                    "value": this.data.currentLevel.totalEvaluationCriteria=='' || this.data.currentLevel.totalEvaluationCriteria==null || isNaN(Number(this.data.currentLevel.totalEvaluationCriteria)) ? '0' :  parseFloat(this.data.currentLevel.totalEvaluationCriteria).toFixed(2)
                }
                ]));
        if (this.data.currentLevel.percentage && this.data.currentLevel.parentCategoryObject?.subCategoriresObject) {
            const parentAllCategories = this.data.currentLevel.parentCategoryObject.subCategoriresObject.length;
            const parentCompletedCategories = this.data.currentLevel.parentCategoryObject.subCategoriresObject.filter(q => q.percentage == 100).length;
            this.data.currentLevel.parentCategoryObject.percentage = Math.ceil((parentCompletedCategories / parentAllCategories) * 100);

            const categoryStat = this.calcCategoryStat(this.data.currentLevel.parentCategoryObject, questionBeforeUpdate);
            this.data.currentLevel.parentCategoryObject.numberOfApplicable = categoryStat.numberOfApplicable;
            this.data.currentLevel.parentCategoryObject.totalEvaluationCriteria = parseFloat(categoryStat.totalEvaluationCriteria).toFixed(2);


            calls.push(this.resourceNameService.
                patchSubmission(this.data.customOptions.categoryResource,
                    this.data.currentLevel.parentCategoryObject._id,
                    [{

                        "op": "add",
                        "path": "/data/percentage",
                        "value": this.data.currentLevel.parentCategoryObject.percentage
                    },
                    {

                        "op": "add",
                        "path": "/data/scoreResult",
                        "value": parseFloat(this.data.currentLevel.parentCategoryObject.calculatedScore).toFixed(2)
                       
                    },
                    {

                        "op": "add",
                        "path": "/data/numberOfApplicable",
                        "value": this.data.currentLevel.parentCategoryObject.numberOfApplicable
                    },
                    {

                        "op": "add",
                        "path": "/data/totalEvaluationCriteria",
                        "value": this.data.currentLevel.parentCategoryObject.totalEvaluationCriteria=='' || this.data.currentLevel.parentCategoryObject.totalEvaluationCriteria==null || isNaN(Number(this.data.currentLevel.parentCategoryObject.totalEvaluationCriteria)) ? '0' : parseFloat(this.data.currentLevel.parentCategoryObject.totalEvaluationCriteria).toFixed(2)
                        
                    }]));
        }
        this.sub = forkJoin(calls).subscribe(data => {
            this.data.currentLevel.scoreResult = parseFloat(this.data.currentLevel.calculatedScore).toFixed(2);
            this.categoryHasChanged.emit(this.data.currentLevel);
            if (data.length > 1) this.data.currentLevel.parentCategoryObject.scoreResult = parseFloat(this.data.currentLevel.parentCategoryObject.calculatedScore).toFixed(2);
            this.formioLoader.loading = false;
            showToast(this.toastrService,
                this.translateService.instant("forms.common.Saved done"),
                this.translateService.instant("forms.common.Saved Successfully"),
                false
            );
        }, error => {
            this.formioLoader.loading = false;
            showToast(this.toastrService,
                this.translateService.instant("ErrorOccurred"),
                this.translateService.instant("generalError"),
                true
            );
        });
    }

    questionLoadion(event) {
        this.formioLoader.loading = event;
    }

    private calcCategoryStat(category: CategoryConfig, questionBeforeUpdate: QuestionConfig) {
        let totalEvaluationCriteria = category.totalEvaluationCriteria || 0;
        let numberOfApplicable = category.numberOfApplicable || 0;

        if (questionBeforeUpdate &&
            ((!questionBeforeUpdate.notApply && questionBeforeUpdate.value) ||
                (this.currentQuestion.notApply && questionBeforeUpdate.value && questionBeforeUpdate.notApply != this.currentQuestion.notApply))) {
            //remove old answer and then reCalc variables
            totalEvaluationCriteria -= (+questionBeforeUpdate.value || 0) * (questionBeforeUpdate.weight || 1);
            numberOfApplicable -= questionBeforeUpdate.weight || 1;
        }
        if (!this.currentQuestion.notApply) {
            totalEvaluationCriteria += (+this.currentQuestion.value || 0) * (this.currentQuestion.weight || 1);
            numberOfApplicable += this.currentQuestion.weight || 1;
            
            
        }
        if(category.questionsAssessmentObject){
                numberOfApplicable = category.questionsAssessmentObject.filter(item=>!item.notApply && item.value!=null).length ?? 0;
                totalEvaluationCriteria = category.questionsAssessmentObject
                                        .filter(item => !item.notApply && item.value!=null) // Filter items where notApply is false
                                        .reduce((sum, item) => sum + Number(item.value), 0) ?? 0; // Sum the values
            }else{
                // items.reduce((sum, item) => sum + item.numberOfApplicable, 0);
                if(category.subCategoriresObject){
                    numberOfApplicable = category.subCategoriresObject.reduce((sum, item) => sum + Number(item.numberOfApplicable), 0)?? 0;
                    totalEvaluationCriteria = category.subCategoriresObject.reduce((sum, item) => sum + Number(item.totalEvaluationCriteria), 0)?? 0;
                }
            }
        return {
            totalEvaluationCriteria: Number(totalEvaluationCriteria).toFixed(2),
            numberOfApplicable: numberOfApplicable
        }
    }

    private loadData(category: CategoryConfig) {
        this.formioLoader.loading = true;
        this.currentQuestion = null;
        if (category.questionsAssessment?.length) {
            if (category.questionsAssessmentObject?.length) {
                this.formioLoader.loading = false;
                this.selectDefaultQuestion();
                return;
            } else {
                this.loadQuestions(category);
            }
        } else {
            if (category.subCategoriresObject?.length) {
                this.formioLoader.loading = false;
                return;
            } else {
                this.loadSubCategores(category);
            }
        }
    }

    private loadSubCategores(category: CategoryConfig, withResult = false) {
        const categoryResource = Utils.interpolate(this.data.customOptions.categoryResource, { data: this.data.data });
        const subCategoryQuery = Utils.interpolate(this.data.customOptions.subCategoryQuery, { data: this.data.data, key: category.key });

        const method = this.resourceNameService.loadCustomByFilterdKey(categoryResource, `${subCategoryQuery}`)
            .pipe(tap((result: any[]) => {
                category.subCategoriresObject = SortHelper.recursiveSort(result.map<CategoryConfig>(c => {
                    const item = new CategoryConfig();
                    const mappedItem = { _id: c._id, ...c.data };
                    item.color = category.color;
                    SortHelper.copyProps(mappedItem, item);
                    if (item.optionalInputs)
                        item.optionalInputs = item.optionalInputs.map(o => {
                            const oInput = new OptionalInputConfig();
                            SortHelper.copyProps(o, oInput);
                            return oInput;
                        });
                    else item.optionalInputs = [];
                    item.parentCategoryObject = category;
                    item.processConfigObject = this.data.processConfig;
                    return item;
                }), 'asc');
            }));
        if (withResult) return method;
        this.sub = method.subscribe(result => {
            this.initProgressColor();
            this.formioLoader.loading = false;
        }, error => this.formioLoader.loading = false);
    }

    private loadQuestions(category: CategoryConfig) {
        const questionsResource = Utils.interpolate(this.data.customOptions.questionsResource, { data: this.data.data });
        const questionsSelect = Utils.interpolate(this.data.customOptions.questionsSelect, { data: this.data.data, category: category });
        this.sub = this.resourceNameService.loadCustomByFilterdKey(questionsResource, `${questionsSelect}`)
            .subscribe((result: any[]) => {
                category.questionsAssessmentObject = SortHelper.sort(result.map<QuestionConfig>(c => {
                    const item = new QuestionConfig();
                    const mappedItem = { _id: c._id, ...c.data };
                    SortHelper.copyProps(mappedItem, item);
                    item.parentCategoryObject = category;

                    item.answerTooltip = item.answerTooltip?.map(a => {
                        const aInput = new AnswerConfig();
                        SortHelper.copyProps(a, aInput);
                        return aInput;
                    }) || [];

                    item.attachments = item.attachments?.map(a => {
                        const aInput = new AttachmentsConfig();
                        SortHelper.copyProps(a, aInput);
                        return aInput;
                    }) || [];

                    item.evaluationItems = SortHelper.recursiveSort(item.evaluationItems?.map(a => {
                        const aInput = new EvaluationItemsConfig();
                        !a.score ? a.score = '' : a.score = +a.score;
                        SortHelper.copyProps(a, aInput);
                        return aInput;
                    }) || [], 'asc');

                    if (item.hasEvaluationItems) {
                        item.evaluationLevels = this.data.processConfig.evaluationLevels;
                    }

                    return item;
                }), this.data.dir == 'rtl' ? 'desc' : 'asc');

                this.selectDefaultQuestion();
                this.formioLoader.loading = false;
            }, error => this.formioLoader.loading = false);
    }

    private initProgressColor() {
        setTimeout(() => {
            if (this.data.currentLevel.subCategoriresObject && this.data.currentLevel.subCategoriresObject.length) {
                this.data.currentLevel.subCategoriresObject.forEach(item => {
                    $(`#bar_${item._id} .p-progressbar-value`).css("background-color", item.color);
                });
            }
        });
    }

    private selectDefaultQuestion() {
        if (this.data.processConfig.categoryLevelCount == this.data.currentLevel.levelNumber && this.data.currentLevel.questionsAssessmentObject) {
            setTimeout(() => {
                const index = this.data.dir == 'rtl' ? this.data.currentLevel.questionsAssessmentObject.length - 1 : 0;
                this.selectQuestion(this.data.currentLevel.questionsAssessmentObject[index]);
            }, 100);
        }
    }
}
